<template>
	<div class="d-flex">
		<div>
			<router-link :to="{ name: 'Group', params: { id: item.id } }">
				<avatar :group="item" />
			</router-link>
		</div>
		<div class="pl-2 flex-grow-1">
			<div class="d-flex justify-content-between">
				<router-link :to="{ name: 'Group', params: { id: item.id } }" class="text-decoration-none">
					<div class="grey--text text--darken-2 font-weight-bold">
						{{ item.name }}
					</div>
					<div class="grey--text font-12">
						{{ item.users_count }} członków w grupie
					</div>
				</router-link>
				<div>
					<div class="d-flex">
						<div>
							<v-btn
								:ripple="false"
								color="white"
								elevation="0"
								class="grey--text mr-3"
								style="pointer-events: none"
							>
								<template v-if="item.is_public">
									<v-icon class="font-14 mr-2">mdi-web</v-icon> Publiczna
								</template>
								<template v-else>
									<v-icon class="font-14 mr-2">$ban</v-icon> Prywatna
								</template>
							</v-btn>
						</div>
						<div>
							<v-btn
								color="grey lighten-2"
								elevation="0"
								class="grey--text"
								v-if="item.permissions.status === 'accepted'"
								style="pointer-events: none"
							>
								Należysz do tej grupy
							</v-btn>
							<template v-else-if="item.permissions.status === 'waiting'">
								<v-btn
									color="grey lighten-2"
									elevation="0"
									class="grey--text"
									@click="$refs['group-join-ask-cancel-modal'].showModal()"
								>
									Wysłano prośbę o dołączenie
								</v-btn>
								<group-join-ask-cancel-modal
									ref="group-join-ask-cancel-modal"
									:groupId="item.id"
								/>
							</template>
							<div v-else-if="item.permissions.status === 'invited'">
								<v-btn
									color="accent lighten-2"
									elevation="0"
									class="accent--text mr-1"
									@click="acceptRejectUser({ id: item.id, status: 'accepted' })"
								>
									Przyjmij zaproszenie
								</v-btn>
								<v-btn
									color="red lighten-1"
									elevation="0"
									class="red--text"
									@click="acceptRejectUser({ id: item.id, status: 'rejected' })"
								>
									Odrzuć zaproszenie
								</v-btn>
							</div>
							<v-btn
								color="accent lighten-2"
								elevation="0"
								class="accent--text"
								v-else-if="!item.permissions.status && item.permissions.can_join"
								@click="requestToJoinGroup({ group: item })"
							>
								<template v-if="item.is_public">
									<v-icon class="font-14 mr-2">mdi-plus</v-icon> Dołącz do grupy
								</template>
								<template v-else>
									Wyślij prośbę o dołączenie do grupy
								</template>
							</v-btn>
						</div>
					</div>
				</div>
			</div>
			<div v-if="item.description" class="mt-3 font-12 grey--text text--darken-2">
				{{ item.description }}
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import GroupJoinAskCancelModal from "@/components/groups/GroupJoinAskCancelModal";
import {mapActions} from "vuex";
export default {
	name: "GroupsListItem",
	components: {
		Avatar,
		GroupJoinAskCancelModal
	},
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	methods: {
		...mapActions('groups', [
			'requestToJoinGroup',
			'acceptRejectUser',
			'cancelRequestGroup'
		])
	}
}
</script>

<style scoped>

</style>
